import React, { useState } from 'react';

import { DebounceOptions, OnChangeHandler, useDebouncedOnChange } from '../../hooks/useDebouncedOnChange';
import { TextField, TextFieldProps } from '../TextField/TextField';

export type DebouncedTextFieldProps = Omit<TextFieldProps, 'value' | 'onChange'> & {
  onChangeHandler: OnChangeHandler;
  debounceOptions?: DebounceOptions;
};

export const DebouncedTextField = (props: DebouncedTextFieldProps) => {
  const { onChangeHandler, debounceOptions, ...textFieldProps } = props;

  const { text, setText, onChangeDebounced } = useDebouncedOnChange(onChangeHandler, debounceOptions);

  // This is needed to support the parent component changing the 'initialValue' without re-rendering
  const [lastInitialValue, setLastInitialValue] = useState(debounceOptions?.initialValue);
  if (debounceOptions?.initialValue !== undefined && lastInitialValue !== debounceOptions?.initialValue) {
    setLastInitialValue(debounceOptions?.initialValue);
    setText(debounceOptions?.initialValue);
  }

  return <TextField {...textFieldProps} value={text} onChange={(e) => onChangeDebounced(e.target.value)} />;
};
